import { render } from "./PreviewCanvas.vue?vue&type=template&id=613d2b4f&scoped=true"
import script from "./PreviewCanvas.vue?vue&type=script&lang=js"
export * from "./PreviewCanvas.vue?vue&type=script&lang=js"

import "./PreviewCanvas.vue?vue&type=style&index=0&id=613d2b4f&lang=css"
import "./PreviewCanvas.vue?vue&type=style&index=1&id=613d2b4f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-613d2b4f"]])

export default __exports__